<div class="container-fluid" style=" background-color: black; height: 100%;">
    <div class="row">
        <div class="col-lg-12 text-center">
            <br>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-9 col-12 order-lg-1  order-sm-2 order-2">
            <p-dataView #dv [value]="products" [rows]="5" filterBy="Name" [sortField]="sortField" [paginator]="true"
                [sortOrder]="sortOrder" layout="grid">
                <ng-template pTemplate="header">
                    <div class="">
                        <p-toolbar>
                            <div class="ui-toolbar-group-left" style="display:flex;">
                                <p-dropdown [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Ordenar"
                                    (onChange)="onSortChange($event)" styleClass="mb-2 md:mb-0"></p-dropdown>
                                <span>
                                    <input type="search" placeholder="Filtrar por Nombre" class="form-control"
                                        (input)="dv.filter($any($event.target).value)">
                                    <span class="fa fa-search searchpan"></span></span>
                            </div>
                            <div class="ui-toolbar-group-right ">
                                <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                            </div>
                        </p-toolbar>

                    </div>
                </ng-template>
                <ng-template let-product pTemplate="listItem" class="PEDO">
                    <div class="col-12 lisitemChild">
                        <div class="product-list-item">
                            <div class="product-list-detail">
                                <img class="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round"
                                    width="100px" [src]="'https://ozez23.bsite.net/images/' + product.ImageURL"
                                    [alt]="product.Name" />
                                <div class="product-name">{{product.Name}}</div>
                                <div class="product-description">{{product.Detail}}</div>
                                <!-- <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating> -->
                                <i class="pi pi-tag product-category-icon"></i><span
                                    class="product-category">{{product.ProductSubCategoryName}}</span>
                            </div>
                            <div class="product-list-action">
                                <span class="product-price">{{product.Price | currency:'₡':'code'}}</span>
                                <p-button icon="pi pi-shopping-cart" label="Add to Cart"
                                    [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"
                                    (onClick)="addProduct(product);"></p-button>
                                <!-- <span [class]="'product-badge status-' + product.IsActive.toString()">{{product.IsActive}}</span> -->
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-product pTemplate="gridItem">
                    <div class="col-md-3 col-lg-3 col-12">
                        <div class="product-grid-item card">
                            <div class="product-grid-item-top">
                                <img class="img-thumbnail" [src]="'https://ozez23.bsite.net/images/' + product.ImageURL"
                                    style="width: 200px; height: 200px;" [alt]="product.Name" />
                                <!-- <span [class]="'product-badge status-' + product.IsActive.toString()">{{product.IsActive}}</span> -->
                            </div>
                            <div class="product-grid-item-content">
                                <i class="pi pi-tag product-category-icon"></i>
                                <span class="product-category">{{product.ProductSubCategoryName}}</span>
                                <div class="product-name">{{product.SKU}} - {{product.Name}}</div>
                                <div class="product-description">{{product.Detail}}</div>
                                <!-- <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating> -->
                            </div>
                            <div class="product-grid-item-bottom">
                                <span class="product-price">{{product.Price | currency:'₡':'code'}}</span>
                                <p-button icon="pi pi-shopping-cart" (onClick)="addProduct(product);"
                                    [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"></p-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
        <div class="col-lg-3 col-12 order-lg-2  order-sm-1 order-1 mb-3">
            <p-toolbar>
                <div class="ui-toolbar-group-left">
                    <p-autoComplete [(ngModel)]="selectedId" [disabled]="buttonDisabled" [suggestions]="filteredData"
                        [forceSelection]="true" [dropdown]="true" [minLength]="1" (completeMethod)="onFilter($event)"
                        (onSelect)="onSelect($event)" field="Detail" placeholder="Ordenes Activas.."></p-autoComplete>
                </div>
                <div class="ui-toolbar-group-right d-md-none  d-lg-none d-xl-none actionButtons">
                    <button pButton type="button" [disabled]="buttonDisabled" (click)="onAddNew();" icon="pi pi-plus"
                        class="toolButtonMin"></button>
                </div>
                <div class="ui-toolbar-group-right d-none d-sm-none d-md-block d-lg-block actionButtons"
                    style="float: right;">
                    <button pButton type="button" label="Nuevo" [disabled]="buttonDisabled" (click)="onAddNew();"
                        icon="pi pi-plus" class="toolButton"></button>



                </div>
            </p-toolbar>
            <br>






            <div class="detailBlock" style="background-color: white;">
                <div class="row">
                    <div class="col-lg-12"></div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <h3>Orden #: {{orderNumber}}</h3>
                        <p style="overflow-wrap: anywhere; font-size: 12px;">Clave: {{documentKey}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <p-toolbar>
                            <div class="ui-toolbar-group-left">
                                <label for="name" style="font-weight: bold;">Cliente:</label>&nbsp;
                                <input type="text" [(ngModel)]="clientName" readonly>
                            </div>
                            <div class="ui-toolbar-group-right d-none d-sm-none d-md-block d-lg-block actionButtons">
                                <button pButton type="button" label="Cliente" [disabled]="buttonDisabled"
                                    (click)="onAddClient();" icon="pi pi-plus" class="toolButton"></button>
                            </div>
                        </p-toolbar>
                        <button class="btn d-lg-none" type="button" data-toggle="collapse"
                            data-target="#example-collapse" (click)="collap();">
                            <span class="navbar-light"><i class="fa fa-eye"></i> Ver detalle</span>
                        </button>
                        <span d-lg-none>
                            <p style="color: red;">Items {{itemsCount}}</p>
                        </span>
                        <div class="example-collapse collapse d-lg-block">
                            Detalle:
                            <p-table [columns]="cols" [value]="detail" [paginator]="true" [rows]="5">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                                ariaLabelDesc="Activate to sort in descending order"
                                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                        </th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr style="color:dodgerblue">
                                        <td *ngFor="let col of columns">
                                            {{rowData[col.field]}}
                                        </td>
                                        <td class="text-center">
                                            <a [attr.disabled]="buttonDisabled"><span
                                                    class="fa fa-edit editIcon"></span></a>
                                        </td>
                                        <td class="text-center">
                                            <a [attr.disabled]="buttonDisabled"><span
                                                    class="fa fa-trash trashIcon"></span></a>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <table style="float: right; font-size: 18px;">
                                <tr>
                                    <td style="text-align: left; width: 100px;">Subtotal</td>
                                    <td style="text-align: right;">{{subtotal | currency:'₡':'code'}}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;">Total Dtos.</td>
                                    <td style="text-align: right;">{{discounts | currency:'₡':'code'}}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: left;">Total Iptos.</td>
                                    <td style="text-align: right;">{{taxes | currency:'₡':'code'}}</td>
                                </tr>
                                <tr style="font-weight: bold; border-top-style: solid; border-top-width: 1px; ">
                                    <td style="text-align: left;   ">Total</td>
                                    <td style="text-align: right;  border-top: 1px;">{{total | currency:'₡':'code'}}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br>
                    </div>
                </div>
                <div class="row example-collapse collapse d-lg-block ">
                    <div class="col-lg-12 text-center">
                        <p-toolbar>
                            <div class="ui-toolbar-group-left">
                            </div>
                            <div class="ui-toolbar-group-right   d-md-block d-lg-block actionButtons">
                                <button pButton type="button" label="Nuevo" [disabled]="buttonDisabled"
                                    icon="pi pi-plus" class="toolButton"></button>
                                <button pButton type="button" label="Facturar" [disabled]="buttonDisabled"
                                    icon="pi pi-pencil" class="p-button-success toolButton"></button>
                                <button pButton type="button" label="Cancelar" [disabled]="buttonDisabled"
                                    (click)="onCancelOrder();" icon="pi pi-times"
                                    class="p-button-danger toolButton"></button>
                            </div>
                        </p-toolbar>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 text-center">
            <br>
        </div>
    </div>
</div>



<synergy-spinner [show]="loading"></synergy-spinner>
<p-confirmDialog #cd header="Confirmacion" icon="pi pi-exclamation-triangle">
    <p-footer>
        <div class="row">
            <div class="col-6">
                <button type="button" class="btn btn-danger fixedButton" label="Cancelar"
                    (click)="cd.accept()">Eliminar</button>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-secondary fixedButton" label="Salir"
                    (click)="cd.reject()">Cancelar</button>
            </div>
        </div>
    </p-footer>
</p-confirmDialog>



<p-dialog header="Agregar Cliente" [(visible)]="showClientDialog" [modal]="true" [responsive]="true"
    [style]="{width: '50%', minWidth: '50%'}" [minY]="70" [maximizable]="true" [baseZIndex]="10000">
    <div class="container">

        <div class="row">
            <div class="col-lg-5">
            </div>
            <div class="col-lg-7">
                <p-toolbar>
                    <div class="ui-toolbar-group-left">
                        <p-autoComplete [(ngModel)]="selectedClientId" [suggestions]="filteredClientData"
                            [forceSelection]="true" [dropdown]="true" [minLength]="1"
                            (completeMethod)="onClientFilter($event)" (onSelect)="onClientSelect($event)" field="Name"
                            placeholder="Buscar.."></p-autoComplete>
                    </div>
                    <div class="ui-toolbar-group-right d-md-none  d-lg-none d-xl-none actionButtons">
                        <button pButton type="button" (click)="onAddNewClient();" icon="pi pi-plus"
                            class="toolButtonMin"></button>
                    </div>
                    <div class="ui-toolbar-group-right d-none d-sm-none  d-md-block d-lg-block actionButtons">
                        <button pButton type="button" label="Nuevo" (click)="onAddNewClient();" icon="pi pi-plus"
                            class="toolButton"></button>
                    </div>
                </p-toolbar>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form [formGroup]="masterClientForm" class="formClass boxed" (ngSubmit)="onSubmitClient();">
                    <input type="hidden" name="id" formControlName="id">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="personTypeId" class="required">Tipo de Identificaci&oacute;n:</label>
                                <select placeholder="Seleccione el tipo de identificaci&oacute;n"
                                    formControlName="personTypeId" class="form-control"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['personTypeId'].errors }">
                                    <option *ngFor="let personType of personTypes" [value]="personType.id">
                                        {{personType.name}}
                                    </option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['personTypeId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['personTypeId'].errors['required']">El tipo de
                                        identificaci&oacute;n
                                        es requerido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="identification" class="required">Identificaci&oacute;n:</label>
                                <input type="text" class="form-control" formControlName="identification"
                                    placeholder="Ingrese el numero de identificaci&oacute;n"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['identification'].errors }">
                                <div *ngIf="clientSubmitted && masterControls['identification'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['identification'].errors['required']">El n&uacute;mero de
                                        identificaci&oacute;n es
                                        requerido.</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="name" class="required">Nombre:</label>
                                <input type="text" class="form-control" formControlName="name"
                                    placeholder="Nombre del cliente"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['name'].errors }">
                                <div *ngIf="clientSubmitted && masterControls['name'].errors" class="invalid-feedback">
                                    <div *ngIf="masterControls['name'].errors['required']">El nombre es requerido.</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="lastName" class="required">Apellido:</label>
                                <input type="text" class="form-control" formControlName="lastName"
                                    placeholder="Ingrese el apellido"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['lastName'].errors }">
                            </div>
                            <div class="form-group">
                                <label for="email" class="required">Correo electr&oacute;nico:</label>
                                <input type="text" class="form-control" formControlName="email"
                                    placeholder="Correo del cliente"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['email'].errors }">
                                <div *ngIf="clientSubmitted && masterControls['email'].errors" class="invalid-feedback">
                                    <div *ngIf="masterControls['email'].errors['required']">El correo es requerido.
                                    </div>
                                    <div *ngIf="masterControls['email'].errors['email']">Formato de correo
                                        inv&aacute;lido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="phoneNumber1" class="required">Tel&eacute;fono principal:</label>
                                <input type="text" class="form-control" formControlName="phoneNumber1"
                                    mask="(000) 0000-0000" placeholder="Tel&eacute;fono principal"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['phoneNumber1'].errors }">
                            </div>
                            <div class="form-group">
                                <label for="phoneNumber2" class="required">Tel&eacute;fono secundario:
                                    (opcional)</label>
                                <input type="text" class="form-control" formControlName="phoneNumber2"
                                    mask="(000) 0000-0000" placeholder="Tel&eacute;fono secundario">
                            </div>
                            <div class="form-group">
                                <label for="countryId" class="required">Pa&iacute;s:</label>
                                <select placeholder="Seleccione el pa&iacute;s" formControlName="countryId"
                                    class="form-control" (change)="onSelectCountry($any($event.target).value)"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['countryId'].errors }">
                                    <option *ngFor="let country of countries" [value]="country.Id">{{country.Name}}
                                    </option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['countryId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['countryId'].errors['required']">El pa&iacute;s es
                                        requerido.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="stateId" class="required">Provincia:</label>
                                <select placeholder="Seleccione la provincia" formControlName="stateId"
                                    class="form-control" (change)="onSelectState($any($event.target).value)"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['stateId'].errors }">
                                    <option *ngFor="let state of states" [value]="state.Id">{{state.Name}}</option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['stateId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['stateId'].errors['required']">La provincia es requerida.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="cityId" class="required">Cant&oacute;n:</label>
                                <select placeholder="Seleccione el cant&oacute;n" formControlName="cityId"
                                    class="form-control" (change)="onSelectCity($any($event.target).value)"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['cityId'].errors }">
                                    <option *ngFor="let city of cities" [value]="city.Id">{{city.Name}}</option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['cityId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['cityId'].errors['required']">El cant&oacute;n es
                                        requerido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="districtId" class="required">Distrito:</label>
                                <select placeholder="Seleccione el distrito" formControlName="districtId"
                                    class="form-control" (change)="onSelectDistrict($any($event.target).value)"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['districtId'].errors }">
                                    <option *ngFor="let district of districts" [value]="district.Id">{{district.Name}}
                                    </option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['districtId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['districtId'].errors['required']"> El distrito es
                                        requerido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="neighborhoodId" class="required">Barrio:</label>
                                <select placeholder="Seleccione el barrio" formControlName="neighborhoodId"
                                    class="form-control"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['neighborhoodId'].errors }">
                                    <option *ngFor="let neighborhood of nighboorhoods" [ngValue]="neighborhood.Id">
                                        {{neighborhood.Name}}</option>
                                </select>
                                <div *ngIf="clientSubmitted && masterControls['neighborhoodId'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['neighborhoodId'].errors['required']"> El barrio es
                                        requerido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="address">Direcci&oacute;n:</label>
                                <textarea class="form-control" formControlName="address" rows="3"
                                    placeholder="Ingrese la direcci&oacute;n"
                                    [ngClass]="{'is-invalid': clientSubmitted && masterControls['address'].errors }"></textarea>
                                <div *ngIf="clientSubmitted && masterControls['address'].errors"
                                    class="invalid-feedback">
                                    <div *ngIf="masterControls['address'].errors['required']">La direcci&oacute;n es
                                        requerida.
                                    </div>
                                </div>
                            </div>
                            <div class=" form-group">
                                <label for="Detail">Detalle:</label>
                                <textarea formControlName="detail" class="form-control" rows="3"
                                    placeholder="Ingrese una descripcion"></textarea>
                            </div>
                            <div class="input-group">
                                <div class="form-group">
                                    <label for="isActive">
                                        <input type="checkbox" formControlName="isActive" class="checkbox"> Activo:
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <button type="submit"  id="submitClient" class="btn btn-primary btn-block">Guardar</button>
                            <button type="button" class="btn btn-success btn-block"
                                (click)="onAddClientToOrder();">Agregar</button>
                            <button type="button" class="btn btn-secondary btn-block"
                                (click)="onClientCancel();">Cancelar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- <p-footer>
        <button type="button" pButton icon="pi pi-close" (click)="showClientDialog=false" label="Cerrar"></button>
    </p-footer> -->
</p-dialog>